import request from '@/utils/request'

export function login (username, password) {
  const data = {
    username,
    password
  }
  return request({
    url: '/index/login',
    method: 'post',
    data
  })
}

export function logout () {
  return request({
    url: '/index/logout',
    method: 'post'
  })
}

export function getUserInfo (token) {
  return request({
    url: '/index/info',
    method: 'get',
    params: { token }
  })
}

export function getUnreadCount () {
  return request({
    url: 'message/count',
    method: 'get'
  })
}

export function getMessage () {
  return request({
    url: 'message/init',
    method: 'get'
  })
}

export function getContentByMsgId (msg_id) {
  return request({
    url: 'message/content',
    method: 'get',
    params: {
      msg_id
    }
  })
}

export function hasRead (msg_id) {
  return request({
    url: 'message/has_read',
    method: 'post',
    data: {
      msg_id
    }
  })
}

export function removeReaded (msg_id) {
  return request({
    url: 'message/remove_readed',
    method: 'post',
    data: {
      msg_id
    }
  })
}

export function restoreTrash (msg_id) {
  return request({
    url: 'message/restore',
    method: 'post',
    data: {
      msg_id
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js